// extracted by mini-css-extract-plugin
export default {"cardWrapper":"styles_cardWrapper__00XsK","card":"styles_card__HtysC","cardInner":"styles_cardInner__q25Me","counterWrapper":"styles_counterWrapper__6ZSXe"};